<template>
  <div class="container">
    <div class="intro-x flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left">
      <div class="flex flex-col lg:flex-row items-center justify-center h-screen text-center lg:text-left">
        <div class="-intro-x lg:mr-20">
          <img class="lg:h-auto" :src="imgErrorPage" />
        </div>
        <div class="text-white mt-10 lg:mt-0">
          <div class="intro-x text-8xl font-medium text-theme-6">Error</div>
          <div class="intro-x text-xl lg:text-3xl font-medium mt-5">
            อ๊ะ. หน้านี้ดูเหมือนจะมีปัญหาบางอย่าง
          </div>
          <div class="flex">
            <div class="intro-x text-lg mt-3 mr-2 underline">
              Message
            </div>
            <div class="intro-x text-lg mt-3 mr-2 ">
              :
            </div>
            <div class="intro-x text-lg mt-3">
              {{ message }}
            </div>
          </div>
          <div class="flex">
            <button @click="onBackToHomeClicked" class="intro-x btn py-3 px-4 text-white border-white dark:border-dark-5 dark:text-gray-300 mt-10 mr-5">
              Back to Home
            </button>
            <button @click="onRefreshClicked" class="intro-x btn py-3 px-4 text-white border-white dark:border-dark-5 dark:text-gray-300 mt-10">
              Refresh
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import imgErrorPage from '@/assets/images/error-page256.png'

export default defineComponent({
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  emits: [
    'refresh',
    'error',
    'loaded',
    'already'
  ],
  data: () => ({
    imgErrorPage
  }),
  methods: {
    onBackToHomeClicked() {
      this.router.push('/')
    },
    onRefreshClicked() {
      this.$emit('refresh')
    }
  },
  created() {
    this.router = useRouter()
  },
  mounted() {
    this.$emit('loaded')
  }
})
</script>
